import {
  CustomerInvitationsActions,
  CustomerInvitationsActionTypes
} from '@appStore/customers/actions/customer-invitations.actions';
import { UserInvitation } from '@model';
import { act } from '@ngrx/effects';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: UserInvitation[];
  invitation: UserInvitation;
  creating: boolean;
  created: boolean;
  bulkCreated: boolean;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: [],
  invitation: null,
  created: false,
  creating: false,
  bulkCreated: false
};

export function reducer(state = initialState, action: CustomerInvitationsActions): State {
  switch (action.type) {
    case CustomerInvitationsActionTypes.BulkCreateCustomerInvitations:
      return { ...state, creating: true, created: false };

    case CustomerInvitationsActionTypes.BulkCreateCustomerInvitationsSuccess:
      const addedData = action.payload.filter(x => state.data.every(y => y.id !== x.id));
      return {
        ...state,
        creating: false,
        created: true,
        data:
          action.payload === null
            ? []
            : addedData.some(d => d.existingUser)
            ? state.data
            : [...state.data, ...addedData]
      };
    case CustomerInvitationsActionTypes.BulkCreateCustomerInvitationsFail:
      return {
        ...state,
        creating: false,
        created: false,
        data: []
      };

      case CustomerInvitationsActionTypes.BulkCreateCustomersInvitations:
        return { ...state, creating: true, created: false };
  
      case CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsSuccess:
        // const bulkAddedData = action.payload.filter(x => state.data.every(y => y.id !== x.id));
        return {
          ...state,
          creating: false,
          created: true,
          bulkCreated: action.payload
          // data:
          //   action.payload === null
          //     ? []
          //     : bulkAddedData.some(d => d.existingUser)
          //     ? state.data
          //     : [...state.data, ...addedData]
        };
      case CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsFail:
        return {
          ...state,
          creating: false,
          created: false,
          bulkCreated: false,
          data: []
        };

    case CustomerInvitationsActionTypes.CustomerInvitationsLoadData:
      return { ...state, loading: true, loaded: false, creating: true, created: false };

    case CustomerInvitationsActionTypes.CustomerInvitationsLoadSuccess:
      return {
        ...state,
        data: action.payload,
        loading: false,
        loaded: true,
        created: true,
        creating: false
      };

    case CustomerInvitationsActionTypes.CustomerInvitationsLoadFail:
      return { ...state, data: [], loading: false, loaded: false };

    case CustomerInvitationsActionTypes.CustomerInvitationRemoveSuccess:
      const oldItem = action.payload;
      return { ...state, loaded: true, loading: false, data: state.data.filter(item => item.id !== oldItem.id) };

    case CustomerInvitationsActionTypes.CustomerInvitationSendSuccess:
      const updatedItem = action.payload;
      return {
        ...state,
        loaded: true,
        loading: false,
        data: state.data.map(item => (item.id === updatedItem.id ? updatedItem : item))
      };
  }
  return state;
}

export const getCustomerInvitations = (state: State) => state.data;
export const getCustomerInvitationsLoading = (state: State) => state.loading;
export const getCustomerInvitationsLoaded = (state: State) => state.loaded;
export const getCustomerInvitationsCreated = (state: State) => state.created;
